import React from "react";
import ReactDOM from "react-dom/client";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
// import "../node_modules/slick-carousel/slick/slick.css"; 
// import "../node_modules/slick-carousel/slick/slick-theme.css";

import '../node_modules/react-multi-carousel/lib/styles.css';
 
import "./index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
